export default __webpack_public_path__ + "static/media/ddf-grafik_01.483ce491.png";